/* eslint-disable */
import { ROSTER_DISPLAY_MODE, ROSTER_TAB } from 'views/bookings-v2/bookings-roster-view/components/roster-common-enums';
import { RosterStoreReducers, RosterStoreState } from './types/roster-store';
import { defaultRosterDateFilter, defaultRosterFilters } from './types/roster-store-defaults';

/** @deprecated **/
const rosterStore = {
  /** @deprecated **/
  state: {
    filters: defaultRosterFilters,
    dateFilter: defaultRosterDateFilter,
    selectedTab: ROSTER_TAB.WEEKLY,
    selectedDate: new Date(),
    selectedMode: ROSTER_DISPLAY_MODE.TEAM_MEMBERS,
  } as RosterStoreState,
  /** @deprecated **/
  reducers: {
    setViewFilters: (state, payload) => ({ ...state, filters: payload }),
    setDateFilter: (state, payload) => ({ ...state, dateFilter: payload }),
    setSelectedTab: (state, payload) => ({ ...state, selectedTab: payload }),
    setSelectedDate: (state, payload) => ({ ...state, selectedDate: payload }),
    setSelectedMode: (state, payload) => ({ ...state, selectedMode: payload }),
  } as RosterStoreReducers,
  effects: () => ({}),
};

export default rosterStore;
